/**
 * Canonical survey definitions offered when creating a patient survey link.
 * Derived from the questionnaire registry's `surveyLinkAdministrable` capability
 * (single source of truth) — not a hand-maintained list. Excludes C-SSRS,
 * PHQ-4, branching instruments, Mirah-only, Safety Plan, and NPS.
 * @agentic connections
 */

import {
  QUESTIONNAIRE_REGISTRY,
  SURVEY_LINK_SENDABLE_QUESTIONNAIRE_KEYS,
} from "@benchmark/core/constants";

/** Single selectable questionnaire row in the survey link dialog. @agentic connections */
export type SurveyLinkQuestionnaireOption = {
  url: string;
  label: string;
};

/**
 * Supported questionnaires for the survey link flow, sorted by label for the multi-select UI.
 * @agentic connections
 */
export const SURVEY_LINK_QUESTIONNAIRE_OPTIONS: SurveyLinkQuestionnaireOption[] =
  SURVEY_LINK_SENDABLE_QUESTIONNAIRE_KEYS.map((key) => {
    const q = QUESTIONNAIRE_REGISTRY[key];
    return {
      url: q.url,
      label: `${q.title} (${q.name})`,
    };
  }).sort((a, b) => a.label.localeCompare(b.label));
